<template>

    <m-edit1/>

    <m-section v-bind='{...{},...{}}' :style='"padding-top:64px;"' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container-custom mx-auto" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="rom mx-auto justify-content-center text-center" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"font-size: clamp(22px, 3vw, 34px);\ncolor:black;\nfont-weight:bold;\n\n"' class=" d-inline-block border-primary-buttom text-dark" >
                <template #default>ثبت درخواست تعمیر   </template>
                </m-h2><m-h4 v-bind='{...{},...{}}' :style='"font-size:18px"' class="text-caption" >
                <template #default>مشکل گوشی خود را در فرم زیر وارد کنید تا کارشناسان ما در اسرع وقت با شما تماس بگیرند


   </template>
                </m-h4></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"margin-top:48px;\npadding: 16px 0px;"' class="rom mx-auto justify-content-center text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto px-1 mb-2 " >
                <template #default>   <m-form-step-1 v-bind='{...{"formId":2,"redirectDirectLink":"https:\/\/medicalmobile.ir\/submit-form"},...{}}' :style='""' class="" ></m-form-step-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-section>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection from '@moeinmdn/miw-alpha-components/src/package/Tags/Section'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mFormStep1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormStep/FormStep1/FormStep1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection,mDiv,mH2,mH4,mFormStep1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
